import React, { useState } from "react";
import styles from "../styles/PlaywrightSidebar.module.css";
import { NavLink } from "react-router-dom";

import {
  FaAngleDoubleRight,
  FaAngleDoubleLeft,
  FaMousePointer,
  FaKeyboard,
  FaCheckSquare,
  FaBell,
  FaTable,
  FaWindowRestore,
  FaLocationArrow,
  FaCamera,
  FaLayerGroup,
  FaClock,
  FaFileUpload,
  FaSearch
} from "react-icons/fa";

const PlaywrightSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => setCollapsed(!collapsed);

  const items = [
    { path: "/pw-locators", label: "LOCATORS", icon: <FaSearch /> },
    { path: "/pw-actions", label: "ACTIONS", icon: <FaMousePointer /> },
    { path: "/pw-input", label: "INPUT / TEXT", icon: <FaKeyboard /> },
    { path: "/pw-checkbox", label: "CHECKBOX", icon: <FaCheckSquare /> },
    { path: "/pw-alerts", label: "ALERTS", icon: <FaBell /> },
    { path: "/pw-webtable", label: "WEB TABLE", icon: <FaTable /> },
    { path: "/pw-windows", label: "WINDOW HANDLE", icon: <FaWindowRestore /> },
    { path: "/pw-navigation", label: "NAVIGATION", icon: <FaLocationArrow /> },
    { path: "/pw-screenshot", label: "SCREENSHOT", icon: <FaCamera /> },
    { path: "/pw-frames", label: "FRAMES", icon: <FaLayerGroup /> },
    { path: "/pw-waits", label: "WAITS", icon: <FaClock /> },
    { path: "/pw-form-validation", label: "FORM VALIDATION", icon: <FaCheckSquare /> },
    { path: "/pw-upload", label: "FILE UPLOAD", icon: <FaFileUpload /> },
  ];

  return (
    <div className={`${styles.sidebar} ${collapsed ? styles.collapsed : ""}`}>
      <button className={styles.toggleBtn} onClick={toggleSidebar}>
        {collapsed ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
      </button>


      <div className={styles.menu}>
        {items.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
          >
            <div className={styles.iconLabel}>
              <span className={styles.icon}>{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default PlaywrightSidebar;